import type { PropsWithChildren } from 'react';

export function PageShell({ children }: PropsWithChildren): React.JSX.Element {
  return <main className="page-shell">{children}</main>;
}
